import { getUserContext } from '@cbhq/client-analytics';
import { Client, ErrorSeverity, init } from '@cbhq/error-vitals-web';

import { getStaticConfig } from ':support/config';

let errorVitalsClient: Client | null = null;
let isInitialized = false;

// Create a minimal client with no-ops for all methods while we wait for the real client to be initialized
let currentClient = {
  logError: () => {},
  addBreadcrumb: () => {},
  setUser: () => {},
  clearUser: () => {},
  setGlobalMetadata: () => {},
  setFeatureFlags: () => {},
  internalClient: {},
  options: {},
  globalMetadata: {},
  featureFlags: {},
} as unknown as Client;

export function initErrorVitals() {
  if (isInitialized) return;

  try {
    const { appAnalyticsName, sentryDsn, environmentName, appVersion } = getStaticConfig();

    errorVitalsClient = init({
      appName: appAnalyticsName,
      apiKey: sentryDsn,
      environment: environmentName,
      appVersion,
      useGlobalHandlers: true,
      getUserContext,
    });
    currentClient = errorVitalsClient;
    isInitialized = true;
  } catch (error) {
    // Silently fail - error vitals client will continue to work with no-op methods
    // This prevents the app from crashing if error vitals fails to initialize
  }
}

export function getErrorVitalsClient(): Client {
  return currentClient;
}

// Export the context that can be used immediately
export const errorVitalsClientContext = {
  get client() {
    return getErrorVitalsClient();
  },
};

export const defaultErrorMetadata = {
  context: 'cx_support_hub',
  severity: 'error' as ErrorSeverity,
  isHandled: true,
};
